<template>
    <div>
        <CNavbar expandable="sm" style="background: rgb(4, 24, 45);" >
          <!-- <h1 class="mt-2 ml-4"> Timóteo </h1> --><router-link to="/"> <img class="logo" src="../imagess/pmtlogo.png" alt=""> </router-link>         
          <div class="ml-auto" >
                        
                        <ul class="social_icon">
                           <li> <a href="https://pt-br.facebook.com/prefeituradetimoteo" target="_blank"><i class="fab fa-facebook-f" aria-hidden="true"></i></a></li>
                           <li> <a href="https://www.youtube.com/channel/UCqkWP4avCdnsir_va3reidg" target="_blank"><i class="fab fa-youtube"></i></a></li>
                           <li> <a href="https://api.whatsapp.com/send?phone=5531994990084" target="_blank"><i class="fab fa-whatsapp"></i></a></li>
                           <li> <a href="https://www.instagram.com/prefeituratimoteo" target="_blank"><i class="fab fa-instagram"></i></a></li>
                           <li v-show="loggedin" style="cursor:pointer; color: white; margin-top: 3px;" class="ml-1" @click="removeStorage(), sair()" to="/"><b>Sair <CIcon name="cilAccountLogout" /></b></li>
                        </ul>
                        
                     </div>
        </CNavbar>
<!--        <div class="navbar-nav">
            <ul class="nav">
                <li><router-link class="router" to="/" name="login">Home</router-link></li>
                 <li><router-link class="router" to="/register" name="register">Register</router-link></li> 
                <li><router-link class="router" to="/dashboard" name="dashboard">Dashboard</router-link></li>
                
                 <button class="btn btn-dark" style="float:right;">Log out</button> 
            </ul>             
        </div>     -->   
    </div>
</template>

<script>
import firebase from 'firebase'

export default {
    name:"navbar",
    mounted()
    {
        let dados = localStorage.getItem('dadosApp');

        if(!dados) {
          this.loggedin = false
        } else {
          this.loggedin = true          
          
        }
        
        
        /* firebase.auth().onAuthStateChanged((user)=>{
            console.log(user)
            if(user)
            this.loggedin=true

            else
            this.loggedin=false
        })  */       
    },
    methods:{
        removeStorage() {
             localStorage.removeItem('dadosApp')            
        },
        sair() {
               location.reload(true)
          }        
    },
    data()
    {
        return{
            loggedin:false,
        }
    },
}
</script>
<style scoped>
* {
     box-sizing: border-box !important;
}
html {
     scroll-behavior: smooth;
}

body {
     background: #fff;
     background-repeat: no-repeat;
     background-size: 100% 100%;
     color: #fff;
     font-size: 14px;
     font-family: 'Roboto', sans-serif;
     line-height: 2.4;
     font-weight: normal;
}

.logo {
     width:350px;   
     margin-left: 20px;     
}
.container {
     max-width: 1172px;
}

a {
     color: #1f1f1f;
     text-decoration: none !important;
     outline: none !important;
     -webkit-transition: all .3s ease-in-out;
     -moz-transition: all .3s ease-in-out;
     -ms-transition: all .3s ease-in-out;
     -o-transition: all .3s ease-in-out;
     transition: all .3s ease-in-out;
}

*,
*::after,
*::before {
     -webkit-box-sizing: border-box;
     -moz-box-sizing: border-box;
     box-sizing: border-box;
}



ul,
li,
ol {
     margin: 0px;
     padding: 0px;
     list-style: none;
}


a {
     color: #222222;
     text-decoration: none;
     outline: none !important;
}

a
 {
     text-decoration: none !important;
     outline: none !important;
     -webkit-transition: all .3s ease-in-out;
     -moz-transition: all .3s ease-in-out;
     -ms-transition: all .3s ease-in-out;
     -o-transition: all .3s ease-in-out;
     transition: all .3s ease-in-out;
}









/*-- navigation--*/

.navbar {
        padding-top: 0.5rem;
        padding-bottom: 0.7rem;
        padding-right: 1.4rem
}

.le_co i {
     color: #fbca47 !important;
}



ul.social_icon li {
     float: left;
     height: 15px;
     padding-right: 7px;
     margin-bottom: 10px;
}



ul.social_icon li a {
     color: #180552;
     width: 30px;
     height: 30px;
     background: #fff;
     float: right;
     text-align: center;
     line-height: 30px;
     border-radius: 100%;
     font-size: 15px;
}

ul.social_icon li a:hover {
     background: #fbca47;
     color: #000;
}


ul.img_icon {
     float: left;
}

ul.img_icon li {
     display: block;
     padding-bottom: 10px;
     float: left;
     padding-right: 10px;
}

.copyright {
     margin-top: 70px;
     padding: 0px 0px 20px 0px;
}

.copyright p {
     color: #fff;
     font-size: 18px;
     line-height: 22px;
     text-align: center;
     padding-top: 25px;
     border-top: #301e64 solid 1px;
}

.copyright a {
     color: #fff;
}

.copyright a:hover {
     color: #fbca47;
}


/** end footer **/
/* Media Queries */
/* Card sizing */
/* Colors */
/* Calculations */
/* Placeholders */

/*--------------------------------------------------------------------- File Name: responsive.css ---------------------------------------------------------------------*/


nav {
  margin-bottom: 0px;
}


@media (min-width: 992px) {
    .ban {
        align-self: center;
    }
    
}

@media (max-width: 692px) {
    .logo {
     width:250px;
     height: auto;   
     margin-left: 20px;     
     }
}    

@media (max-width: 592px) {
    .logo {
     width:150px;
     height: auto;   
     margin-left: 5px;     
     }    
     nav {
     height: 60px;
     }
     
}

@media (max-width: 452px) {
    .logo {
     width:124px;
     height: auto;   
     margin-left: 2px;     
     }
}





</style>